<template>

  <generic-card
      :byContent="true"

      @click="$emit('click')"
      @delete="$emit('deleteIncomingInvoice')"
      :allowDelete="('orders' in incomingInvoice) && incomingInvoice.orders.length == 0"
  >
    <template #content>
      <content-incoming-invoice
          :incomingInvoice="incomingInvoice"
          :isParentMethodPriority="true"
          :isPayable="isPayable"
          :isDeletable="false"
          @pay="$emit('pay')"
      />
    </template>

  </generic-card>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'

import GenericCard from './Card'
import ContentIncomingInvoice from './components/IncomingInvoiceContent'

export default {
  components: {
    GenericCard,
    ContentIncomingInvoice
  },
  props: {
    incomingInvoice: {
      type: Object,
      default: () => {}
    },
    isPayable: {
      type: Boolean,
      default: false
    },
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components

      // Data

      // Computed

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>